module.exports = __webpack_public_path__ + "static/media/services-img1.25d02e18.svg";